
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";


// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyC5H374wf2Z6d71VgV5NWcDxtLhZHMHIZg",
  authDomain: "react-login-firbase.firebaseapp.com",
  projectId: "react-login-firbase",
  storageBucket: "react-login-firbase.appspot.com",
  messagingSenderId: "189961149661",
  appId: "1:189961149661:web:37e069c41ccbed2eb18f34"
};


export default firebaseConfig;